<template>
  <div>
    <v-menu
      v-model="isOpen"
      :close-on-content-click="false"
      offset-y
      transition="scale-transition"
      :nudge-top="6"
      :nudge-left="0"
    >
      <template v-slot:activator="{ on, attrs }">
        <slot name="activator" :on="on" :attrs="attrs">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-information</v-icon>
          </v-btn>
        </slot>
      </template>

      <v-card class="tooltip-card" elevation="0">
        <div class="tooltip-head">
          <h4 class="font-weight-medium">Projeção de vendas</h4>

          <v-btn icon small class="btn-x" @click="cancelar">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>

        <div class="subtitle">
          Modelo de previsão atual:
          <span class="chip">
            <v-icon size="17" color="#FF8040" class="mr-1">$ProjectorScreenChart</v-icon>
            {{ descricao_index_tipo_projecao_vendas[tipo_projecao_vendas] }}
          </span>
        </div>

        <v-btn class="btn-primary" block depressed @click="confirmar">
          Editar modelo
        </v-btn>
      </v-card>
    </v-menu>
  </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import {
  descricao_index_tipo_projecao_vendas
} from "@/components/produto/detalhes/ProjecaoVenda/Parametrizacao/Simulacao/Helpers";

const emit = defineEmits(["fechar", "confirmar"]);

const props = defineProps({
  value: { type: Boolean, default: false },
  tipo_projecao_vendas: { type: String, required: true },
});

const opened = ref(props.value);

watch(() => props.value, (v) => (opened.value = v));

const isOpen = computed({
  get: () => opened.value,
  set: (v) => (opened.value = v),
});

function cancelar() {
  isOpen.value = false;
  emit("fechar");
}

function confirmar() {
  isOpen.value = false;
  emit("fechar");
  emit("confirmar");
}
</script>

<style scoped>
.tooltip-card {
  width: 320px;
  background: #fff;
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.12);
  padding: 14px 14px 12px;
  position: relative;
}

.tooltip-card::before {
  content: "";
  position: absolute;
  top: -8px;
  left: 24px;
  width: 16px;
  height: 16px;
  background: #fff;
  transform: rotate(45deg);
  box-shadow: -6px -6px 16px rgba(0, 0, 0, 0.04);
}

.tooltip-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.btn-x {
  margin-right: -6px;
}

.subtitle {
  display: flex;
  flex-direction: column;
  font-size: 13px;
  line-height: 1.35;
  color: #39404B;
  margin-top: -5px;
  margin-bottom: 12px;
}

.chip {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  margin-top: 6px;
  padding: 4px 10px;
  border-radius: 7px;
  background: #FFF3EC;
  color: #FF8040;
  font-weight: 400;
}

.btn-primary {
  border-radius: 7px;
  background: #4075FF !important;
  color: #fff !important;
  font-size: 14px;
  text-transform: none;
  font-weight: 500;
  height: 44px;
  margin-top: 30px;
}
</style>
